import classNames from 'classnames';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants/messages';
import { ErrorBoundary } from '@/shared/ui/ErrorBoundary';

import {
  DataAssetQuality,
  DataTestCaseResults,
  DataZoneCountArticle,
  DataZoneLoadStatus,
} from '@/widgets/quality/dashboard';

import styles from './DataQualityDashboardPage.module.css';

export const DataQualityDashboardPage = () => {
  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <div className={styles.title}>데이터 품질 대시보드</div>
        <div className={styles.description}>전체 데이터 자산의 품질 상태를 모니터링 합니다.</div>
      </div>
      <div className={styles.mainContent}>
        <div className={styles.topRow}>
          <article className={classNames(styles.card, styles.dataZoneCountArticle)}>
            <ErrorBoundary title="" description={NOTIFICATION_MESSAGES.DATA_ZONE_COUNT_ERROR_DESC}>
              <DataZoneCountArticle />
            </ErrorBoundary>
          </article>

          <article className={classNames(styles.card, styles.dataTestCaseResults)}>
            <ErrorBoundary title="" description={NOTIFICATION_MESSAGES.DATA_TEST_CASE_RESULTS_ERROR_DESC}>
              <DataTestCaseResults />
            </ErrorBoundary>
          </article>

          <article className={styles.dataZoneLoadStatus}>
            <ErrorBoundary title="" description={NOTIFICATION_MESSAGES.DATA_ZONE_LOAD_STATUS_ERROR_DESC}>
              <DataZoneLoadStatus />
            </ErrorBoundary>
          </article>
        </div>

        <article className={styles.bottomRow}>
          <ErrorBoundary title="" description={NOTIFICATION_MESSAGES.DATA_ASSET_QUALITY_ERROR_DESC}>
            <DataAssetQuality />
          </ErrorBoundary>
        </article>
      </div>
    </section>
  );
};
